export function compileSpreadInputHandlers(
  spreadInputHandlersBody: string
): string {
  return `(inputs, outputs, state, params) => {
  ${spreadInputHandlersBody}
}`;
}
